// extracted by mini-css-extract-plugin
export default {"container":"yellow_warning_icon-module___container___bf03d328","icon":"yellow_warning_icon-module___icon___b342749d","bar":"yellow_warning_icon-module___bar___f2a6be42"};